import { ICustomer } from "./ICustomer";
import { ISignText } from "./ISignText";
import { ISymbol } from "./ISymbol";

export interface ISignForm {
  quantity: number;
  quantityPrice: number;
  totalPrice: number;
  graffitiProtection: boolean;
  mount?: SignMount;
  mountingPoint?: MountingPoint;
  needsMounting?: boolean;
  mountTotal?: number;
  width: number;
  height: number;
  poleDimension?: number;
  primaryColor: SignColor;
  primaryColorCode: SignColorCode;
  secondaryColor: SignColor;
  secondaryColorCode: SignColorCode;
  reflex?: Reflex;
  texts: ISignText[];
  symbol?: ISymbol;
  symbolPlacement?: SymbolPlacement;
  customer: ICustomer;
}

export enum SignMount {
  POLE = "Pole",
  WALL = "Wall",
}

export enum MountingPoint {
  SINGLE = "SingleMount",
  DOUBLE = "DoubleMount",
}

export enum Reflex {
  NORMAL = "Normal",
  HIGH = "High",
}

export enum SignColor {
  BLUE = "Blue",
  YELLOW = "Yellow",
  WHITE = "White",
  RED = "Red",
  BLACK = "Black",
}

export enum SignColorCode {
  BLUE = "#005092",
  YELLOW = "#FED300",
  WHITE = "#FFFFFF",
  RED = "#e73137",
  BLACK = "#2E2E2E",
}

export enum SymbolPlacement {
  CENTER = "Center",
  TOP_LEFT = "TopLeft",
}
